module.exports = __webpack_public_path__ + "img/onlylead02.0f0acac3.png";